'use client';
import { getBreadCrumbsContent } from '@/functions/getSearchParamTitle';

export type BreadCrumbsContent = {
  links: {
    label: string;
    href: string;
  }[];
  current: string;
};

export const useBreadCrumbs = (props: {
  customerSetting: CustomerSetting;
  currentTitle: string;
  searchParams?: SearchParams;
  today?: boolean;
  subPages?: BreadCrumbsContent['links'];
}): BreadCrumbsContent => {
  return getBreadCrumbsContent(
    props.customerSetting,
    props.currentTitle,
    props.searchParams,
    props.today,
    props.subPages
  );
};
